import React from 'react'

const CustomFormLabel = ({
    htmlFor,
    children
}) => {
  return (
    <label htmlFor={htmlFor} className='text-[#000000] font-semibold xs:py-[10px] md:py-2 xstext-[12px] md:text-[14px]' >
        {children}
    </label>
  )
}

export default CustomFormLabel